import React from "react";
import "../Navigation.scss";
import classNames from "classnames";
import FontAwesomeIcon from "../../Icon";
import { NavLink } from "react-router-dom";

export const MyHomeLink = ({ link, collapseSideBar }) => {
  const isLoaded = localStorage.getItem("suiteId") === undefined;
  return (
  <li
    title={link.label}
    className="navigation__link"
    key={`nav-link-${link.label}`}
  >
    {isLoaded ? (
      <LoadingSuite link={link} collapseSideBar={collapseSideBar} />
    ) : (
      <Suite link={link} collapseSideBar={collapseSideBar} />
    )}

  </li>
)};
 
const LoadingSuite = ({link, collapseSideBar}) => (
  <div
    className={classNames("navigation__anchor", {
      "navigation__anchor--collapsed": collapseSideBar,
    })}
    onClick={(link) => alert("Please wait while we load your suites!")}
  >
    <FontAwesomeIcon weight="light" glyph={link.icon} />
    <div
      className={classNames("navigation__anchor--label", {
        "navigation__anchor--label--collapse": collapseSideBar,
      })}
    >
      {link.label}
    </div>
  </div>
);

const Suite = ({link, collapseSideBar}) => (
  <NavLink
    to={{
      pathname: link.path.replace(
        ":id",
        localStorage.getItem("propertyId") +
          "&" +
          localStorage.getItem("suiteId")
      ),
      state: {
        suite: { id: localStorage.getItem("suiteId") },
        property: {
          id: localStorage.getItem("propertyId"),
        },
        activeTab: 0,
        from: "Dashboard",
      },
    }}
    className={classNames("navigation__anchor", {
      "navigation__anchor--collapsed": collapseSideBar,
    })}
    activeClassName="navigation__anchor--active"
  >
    <FontAwesomeIcon weight="light" glyph={link.icon} />
    <div
      className={classNames("navigation__anchor--label", {
        "navigation__anchor--label--collapse": collapseSideBar,
      })}
    >
      {link.label}
    </div>
  </NavLink>
)
